<template>
    <div class="column search-results-layout">
        <div class="row stretch" style="margin:0.5em 0">
            <label class="srl-1">{{texts.layout.type}}</label>
            <RadioGroup class="srl-2" :items="this.radioGroups" :name="name+'-layout-type'" @input="setType" style="margin-bottom: 0;"/>
        </div>
        <div v-if="config.type==='grid'" class="row stretch" style="margin: 0.5em 0;">
            <label :for="name+'sm-grid--i'">{{texts.layout.columnCount}} ({{breakpoint}}{{texts.layout.bp}})</label>
            <input :id="name+'sm-grid--i'" type="number" @change="setSmColumns" :value="smCols" min="1" max="10"/>
        </div>   
        <div v-if="config.type==='grid'" class="row stretch" style="margin: 0.5em 0;">
            <label :for="name+'lg-grid--i'">{{texts.layout.columnCount}} ({{texts.layout.default}})</label>
            <input :id="name+'lg-grid--i'" type="number" @change="setLgColumns" :value="lgCols" min="1" max="10"/>
        </div>   
        <Checkmark :checkbox-id="name+'-show-img--i'" :label="texts.global.showImages" v-model="config.showImages"/>
        <Checkmark :checkbox-id="name+'-show-url--i'" :label="texts.layout.showUrl" v-model="config.showUrl"/>
        <Checkmark :checkbox-id="name+'-show-snippet--i'" :label="texts.layout.showSnippet" v-model="config.showSnippet"/>
        <Checkmark :checkbox-id="name+'-show-title--i'" :label="texts.layout.showTitle" v-model="config.showTitle"/>
    </div>
</template>

<script>
import Vue from 'vue';
import RadioGroup from '../RadioGroup';
import Checkmark from '../Checkmark';

export default {
    name: "SearchResultsLayoutGroup",
    props: {
        name:{
            type: String, 
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        breakpoint:{
            type: String,
            required: true
        }
    },
    components: {RadioGroup, Checkmark},
    computed: {
        smCols(){return this.name==="desktop"?this.config.gridColsLg : this.config.gridColsSm},
        lgCols(){return this.name==="desktop"?this.config.gridColsXl : this.config.gridColsMd},
        radioGroups(){
            return [
                {
                id: this.name + "-list--i",
                isActive: this.config.type==='list',
                label: this.texts.layout.list,
                value: 'list'
            },
            {
                id: this.name + "-grid--i",
                isActive: this.config.type==='grid',
                label: this.texts.layout.grid,
                value: 'grid'
            },
            {
                id: this.name + "-grid--i",
                isActive: this.config.type==='masonry',
                label: this.texts.layout.masonry,
                value: 'masonry'
            },
            ]
        }
    },
    methods: {
        setType(value){Vue.set(this.config, 'type', value)},
        setSmColumns(e){var key = this.name==="desktop" ? "gridColsLg":"gridColsSm"; Vue.set(this.config, key, parseInt(e.target.value))},
        setLgColumns(e){var key = this.name==="desktop" ? "gridColsXl":"gridColsMd"; Vue.set(this.config, key, parseInt(e.target.value))}
    }
};
</script>

<style>
.column.search-results-layout{
    width: 100%; 
    max-width:500px;
    align-items: flex-start;
}

#app .srl-1, #app .srl-2{
    flex: 1;
}

#app .srl-2{
    justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/SearchResultsLayoutGroup.vue